import React, { useState } from "react";
import { Display1, Display, DisplayMoney, InlineInput } from "../workspace";
import { useAppContext } from "../../context/appContext";
import { moneyToNumber } from "../../utils/money";
import calculatePrices from "../../utils/calcJobItemTotal";
import ConfirmBox from "../ConfirmBox";
import { calcTotalCost } from "../../utils/calcCost";

function ReviewItems() {
  const {
    reviewItems,
    lists,
    isLoading,
    job,
    customer,
    options,
    prices,
    handleArrayChange,
    indices,
  } = useAppContext();

  const priceSheet = job.price_sheets_id;
  const laborPrices = prices?.laborPrices?.filter(
    (price) => parseInt(price.price_sheets_id) === parseInt(priceSheet)
  )[0];

  const handleInput = (e, index) => {
    console.log("e.target.name:", e.target.name)
    console.log("e.target.value:", e.target.value)
    console.log("index:", index)
    handleArrayChange({
      baseName: "reviewItems",
      baseArray: reviewItems,
      index,
      property: e.target.name,
      value: e.target.value,
    });
  };

  return (
    <div name="job-items" className="subform">
      {reviewItems?.map((item, index) => {
        const {
          work_types_id,
          quantity,
          skylight_sizes_id,
          frame_types_id,
          top_glazing_id,
          bottom_glazing_id,
          glazing_materials_id,
          tube_depths_id,
          work_description,
          extras_ids,
          base_price,
          extras_price,
          custom_price,
          cost_retail,
          cost_materials,
          cost_labor,
        } = item;

        // convert money string to a number
        const basePrice = moneyToNumber(base_price);
        const extrasPrice = moneyToNumber(extras_price);
        const customPrice = moneyToNumber(custom_price);
        const costRetail = moneyToNumber(cost_retail);
        const costMaterials = moneyToNumber(cost_materials);
        const laborPrice = Number(laborPrices?.labor_cost || 0);
        const price = basePrice + extrasPrice || custom_price;

        let unitPrice = customPrice // if custom price
          ? customPrice // use custom price
          : basePrice + extrasPrice; // else calculate price
        const ttlPrice = unitPrice * quantity;

        const { tax, laborTotalCost, totalCost, profit } = calcTotalCost(
          costRetail,
          costMaterials,
          cost_labor,
          laborPrice,
          unitPrice
        );

        // build values
        const jobType = // if value present
          (work_types_id &&
            lists.listWorkTypes?.find((type) => {
              return type.id === work_types_id;
            }).text) ||
          ""; // blank string if not found
        const size = // if value present (including 0)
          ((skylight_sizes_id || skylight_sizes_id === 0) &&
            lists.listSkylightSizes?.find((size) => {
              return size.id === skylight_sizes_id;
            }).text) ||
          "";
        const depth = // if value present (including 0)
          ((tube_depths_id || tube_depths_id === 0) &&
            lists.listTubeDepths?.find((depth) => {
              return depth.id === tube_depths_id;
            }).text) ||
          "";
        const frame = // if value present (including 0)
          ((frame_types_id || frame_types_id === 0) &&
            lists.listFrameTypes?.find((frame) => {
              return frame.id === frame_types_id;
            }).text) ||
          "";
        const glazingMaterial =
          (glazing_materials_id &&
            lists.listGlazingMaterials?.find((glazing) => {
              return glazing.id === glazing_materials_id;
            }).text) ||
          "";
        const glazingColors = top_glazing_id // add if top glazing is present
          ? (top_glazing_id &&
              lists.listGlazingColors?.find((glazing) => {
                return glazing.id === top_glazing_id;
              }).text) +
            (bottom_glazing_id // add if bottom glazing is present
              ? "/" +
                (bottom_glazing_id &&
                  lists.listGlazingColors?.find((glazing) => {
                    return glazing.id === bottom_glazing_id;
                  }).text)
              : "")
          : "";
        const glazing = `${glazingColors} ${glazingMaterial}`;
        const extras = extras_ids
          ?.map((chosenExtra) => {
            return (
              lists.listExtras?.find((listedExtra) => {
                return listedExtra.id === chosenExtra;
              })?.text || ""
            );
          })
          .toString();

        return (
          <div name={`job-item-${index}`} className="form-center sub-item" key={index}>
            {/* Top Row */}
            <div className="whole flex-parent">
              <h5>
              {`${jobType}: ${size} ${frame} - `} 
              {work_types_id !== 5 ? (
                // for all standard skylights
                <>
                  {glazing}
                </>
              ) : (
                // for sun tunnels
                <>
                  {`${depth}; ${extras}`}
                </>
              )}
            </h5>
            </div>
            {/* Details Row */}
            <div className="whole details">
              <Display1 name="details" value={work_description || ""} handleChange={() => {}} />
            </div>
            <div className="divider"></div>
            {/* Column 2A - Prices */}
            <div className="one-third flex-parent">
              <DisplayMoney name="base price" className="whole" value={customPrice || basePrice} />
              <DisplayMoney name="line items" className="whole" value={extrasPrice} />
              <DisplayMoney name="unit price" className="whole" value={unitPrice} />
            </div>
            {/* Column 2B - Costs */}
            <div className="flex-parent one-third">
              <InlineInput
                name="cost_retail"
                labelText="Retail Cost"
                inputMode="numeric"
                value={costRetail || ""}
                handleChange={(e) => handleInput(e, index)}
              />
              <InlineInput
                name="cost_materials"
                labelText="Materials Cost"
                inputMode="numeric"
                value={costMaterials || ""}
                handleChange={(e) => handleInput(e, index)}
              />
              <InlineInput
                name="cost_labor"
                labelText="Hours of Labor"
                inputMode="numeric"
                value={cost_labor || ""}
                handleChange={(e) => handleInput(e, index)}
              />
              <DisplayMoney name="Labor Cost" className="whole" value={laborPrice * cost_labor} />
            </div>
            {/* Column 2C - Profit */}
            <div className="flex-parent one-third">
              <DisplayMoney name="Unit Cost" className="whole" value={totalCost} />
              <DisplayMoney name="Unit Profit" className="whole" value={profit} />
              <Display name="Quantity" className="whole" value={quantity} />
              <DisplayMoney name="Total Profit" className="whole" value={profit * quantity} />
            </div>

          </div>
        );
      })}
    </div>
  );
}
export default ReviewItems;
